import * as React from "react";
const SvgFiRrHexagonCheck = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-hexagon-check_svg__a)">
      <path
        fill="#062147"
        d="M18.214 9.098a1 1 0 0 1-.014 1.414l-4.426 4.345a3.98 3.98 0 0 1-2.799 1.151 3.99 3.99 0 0 1-2.777-1.129L6.3 13.011a1 1 0 1 1 1.402-1.426l1.893 1.861c.778.75 2.002.746 2.781-.018L16.8 9.084a1 1 0 0 1 1.414.014m5.143 5.422-3.5 6A5.02 5.02 0 0 1 15.538 23H8.466a5.02 5.02 0 0 1-4.319-2.48l-3.5-6a5 5 0 0 1 0-5.039l3.5-6a5.02 5.02 0 0 1 4.318-2.48h7.072c1.771 0 3.426.951 4.318 2.48l3.501 6a5.01 5.01 0 0 1 .001 5.039m-1.729-4.031-3.5-6a3.01 3.01 0 0 0-2.59-1.488H8.464c-1.063 0-2.056.57-2.59 1.488l-3.5 6a3 3 0 0 0 0 3.023l3.5 6A3.01 3.01 0 0 0 8.464 21h7.072c1.062 0 2.056-.57 2.592-1.488l3.5-6a3 3 0 0 0 0-3.023"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-hexagon-check_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrHexagonCheck;
